module.exports = __webpack_public_path__ + "media/directory/location_icon_grey-2a4c5ee9.svg";